
import { EN_KO } from '../helpers/GlobalsHelper';

const safeRunFunc = ( func ) => {
	try {
		func();
	} catch ( err ) {
		console.log( err ); // eslint-disable-line no-console
	}
}

const runDeferredExecutes = function() {
	// run deferred functions
	if ( Array.isArray( EN_KO.deferredExecute ) ) {

		// Call all functions in the array.
		EN_KO.deferredExecute.forEach( ( func ) => safeRunFunc( func ) );

		// Subsequent calls to deferred execute.push are executed immediately.
		EN_KO.deferredExecute = {
			push: ( func ) => safeRunFunc( func )
		}
	}
}


export {
	runDeferredExecutes,
	safeRunFunc
}